import React from 'react';

const Vue_v_on = () => {
  return (
    <div>
      <h1>Vue_v_on Component</h1>
      <p>This is the Vue_v_on tutorial page.</p>
    </div>
  );
}

export default Vue_v_on;
